import script from "./ActivitiesHeatmap.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivitiesHeatmap.vue?vue&type=script&setup=true&lang=js"

import "./ActivitiesHeatmap.vue?vue&type=style&index=0&id=5745d674&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5745d674"]])

export default __exports__